; (function (window, document, $) {
    'use strict';
    
    var defaultOptions = {
        toggleButtonSelector: '[data-component="toggleable-button"]',
        itemSelector: '[data-component="toggleable-item"]',
        itemActiveClass: 'is-selected'
    };

    var toggleable = {
        init: function ($element, options) {
            this.options = $.extend({}, defaultOptions, options);

            this.$element = $element;
            this.$items = this.$element.find(this.options.itemSelector);

            this.initActiveItem();

            this.initEvents();

            return this;
        },
        initActiveItem: function() {
            this.$activeItem = this.$items.filter('.' + this.options.itemActiveClass);
        },
        initEvents: function () {
            this.$items.on('click.toggleable', this.options.toggleButtonSelector, this.onClick.bind(this));
        },
        destroyEvents: function () {
            this.$element.off('.toggleable');
        },
        onClick: function (e) {
            e.preventDefault();

            var $targetItem = $(e.target).closest(this.options.itemSelector);

            this.activateItem($targetItem);
        },
        activateItem: function ($item) {
            if (!this.shouldActivate($item)) {
                return;
            }

            this.$activeItem.removeClass(this.options.itemActiveClass);
            $item.addClass(this.options.itemActiveClass);
            this.$activeItem = $item;

            return this;
        },
        shouldActivate: function ($item) {
            return !$item.hasClass(this.options.itemActiveClass);
        }
    };

    toggleable.init($('[data-component="toggleable"]'));
})(window, document, jQuery);